module.exports = __webpack_public_path__ + "static/media/2. Bajo la lupa, Mixta sobre madera, 100 x 100 cm, 2011 copy.f3ff1952.png";